import { Button, Input, Modal, Text } from '@bbl-digital/snorre-v2'
import { useFileuploadPickerContext } from '../context/useFileuploadPickerContext'
import { Step } from '../types/types'
import ArchiveFilePickerList from './list/ArchiveFilePickerList'
import ArchiveFileSearchList from './list/ArhiveFileSearchList'

const ArchiveFilePicker = () => {
  const { setStep, archiveSearchText, setArchiveSearchText, files } =
    useFileuploadPickerContext()

  const anyArchiveFilesSelected = files.some((file) => file.isArchive)

  return (
    <>
      <Modal.Header>Legg til vedlegg</Modal.Header>
      <Modal.Block className="flex flex-col space-y-2">
        <Input
          placeholder="Søk i styrets arkiv..."
          defaultValue={archiveSearchText}
          onChange={(e) => setArchiveSearchText(e.target.value)}
        />
        <Text>Velg vedlegg fra styrets arkiv</Text>
        {archiveSearchText && <ArchiveFileSearchList />}
        {!archiveSearchText && <ArchiveFilePickerList />}
      </Modal.Block>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setStep(Step.LOCAL)}>
          Tilbake
        </Button>
        <Button
          disabled={!anyArchiveFilesSelected}
          variant="primary"
          onClick={() => setStep(Step.LOCAL)}
        >
          Fortsett
        </Button>
      </Modal.Footer>
    </>
  )
}

export default ArchiveFilePicker
